import {
  FilterType,
  buildPerformanceReviewsDataTableFilter,
  usePerformanceReviewsDataTable,
} from 'generated/resources/datatable.graphql'
import moment from 'moment'

import { dateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

const dueDateFilter = (source: ReturnType<typeof usePerformanceReviewsDataTable>) => {
  return buildPerformanceReviewsDataTableFilter(source, {
    identifier: 'endsAt',
    title: i18n.t('performance_process.reviews.datatable.due_date'),
    path: 'endsAt',
    type: FilterType.Date,
    categories: [
      {
        kind: 'DateTimePicker',
        operation: 'between',
        value: [
          dateToString(moment(), 'backend_datetime'),
          dateToString(moment(), 'backend_datetime'),
        ],
      },
    ],
  })
}

export default dueDateFilter
